import { updateForm } from '@cinch/oxd-redux/dealer-vehicles/src/actions'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { selectors as lifestyleSelectors } from '@cinch/oxd-redux/lifestyle/src'
import buildFormParams from './build-form-params'
import Component from './recommended-cars.component'

export const FORM_NAME = 'filters'

export const mapStateToProps = (state: any) => ({
  initialValues: lifestyleSelectors.getLifestyleData(state),
})

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClick: (vehicle: Cinch.RecommendationsItem) => {
    const data = buildFormParams(vehicle)
    dispatch(updateForm(data))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
